// 公開無料版ダッシュボードの「お問い合わせ」用連絡先メールアドレス
// 未設定/プレースホルダーのまま公開されるのを防ぐため、読み取りと有効性チェックを一箇所に集約する
const PLACEHOLDER_EMAIL = 'REPLACE_ME_BEFORE_LAUNCH@eigaland.example'
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function getContactEmail() {
  return (import.meta.env.VITE_APP_CONTACT_EMAIL || '').trim()
}

export function isContactEmailConfigured() {
  const email = getContactEmail()
  if (!email || email === PLACEHOLDER_EMAIL) return false
  return EMAIL_PATTERN.test(email)
}
